const initialState = {
  isLoading: false,
  error: false,
  errorMessage: null,
  sendingDialogVisible: false,
  bulkSendResponse: null,
};

const failedState = {
  ...initialState,
  error: true,
  isLoading: false,
  sendingDialogVisible: true,
};

function faxes(state = initialState, action) {
  switch (action.type) {
    case 'BEGIN_SEND_TO_MULTIPLE_RECIPIENTS':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: null,
        sendingDialogVisible: true,
      };
    case 'FINISHED_SEND_TO_MULTIPLE_RECIPIENTS':
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: null,
      };
    case 'FAILED_SEND_TO_MULTIPLE_RECIPIENTS':
      return {
        ...failedState,
        errorMessage:
          action.payload.response.data.message
          || action.payload.response.data.error,
      };
    case 'BEGIN_SEND_PATIENT_RECORD':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: null,
        sendingDialogVisible: true,
      };
    case 'FINISHED_SEND_PATIENT_RECORD':
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: null,
      };
    case 'FAILED_SEND_PATIENT_RECORD':
      return {
        ...failedState,
        errorMessage: action.payload.response.data.error,
      }
    case 'CLOSE_SEND_DIALOG':
      return {
        ...state,
        sendingDialogVisible: false,
      };
    case 'BEGIN_SEND_TO_DISTRIBUTION_LIST':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: null,
        sendingDialogVisible: true,
      };
    case 'FINISHED_SEND_TO_DISTRIBUTION_LIST':
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: null,
      };
    case 'FAILED_SEND_TO_DISTRIBUTION_LIST':
      return {
        ...failedState,
        errorMessage:
          action.payload.response.data.message
          || action.payload.response.data.error,
      };
    case 'BEGIN_SEND_BULK_RECORDS':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: null,
        bulkSendResponse: null,
        sendingDialogVisible: true,
      };
    case 'FINISHED_SEND_BULK_RECORDS':
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: null,
        bulkSendResponse: action.payload.data,
      };
    case 'FAILED_SEND_BULK_RECORDS':
      return {
        ...failedState,
        bulkSendResponse: null,
        errorMessage:
          action.payload.response?.data?.message
          || action.payload.response?.data?.error
          || 'Failed to send records',
      };

    default:
      return state;
  }
}

export default faxes;
